import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { FiFileText } from "react-icons/fi"

import { getFullDetailsOfCourse } from "../services/operations/courseDetailsAPI"
import { setCourse, setEditCourse } from "../slices/courseSlice"
import AssessmentForm from "../components/core/Dashboard/AddCourse/Assessment/AssessmentForm"

export default function CourseAssessmentSetup() {
  const dispatch        = useDispatch()
  const { courseId }    = useParams()
  const { token }       = useSelector((s) => s.auth)
  const { course }      = useSelector((s) => s.course)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      const result = await getFullDetailsOfCourse(courseId, token)
      if (result?.courseDetails) {
        dispatch(setEditCourse(true))
        dispatch(setCourse(result.courseDetails))
      }
      setLoading(false)
    })()
  }, [courseId])

  if (loading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-yellow-50 border-t-transparent" />
      </div>
    )
  }

  if (!course) {
    return (
      <p className="mt-20 text-center text-xl font-semibold text-richblack-100">
        Course not found
      </p>
    )
  }

  return (
    <div>
      <div className="mb-8 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-yellow-50/10">
          <FiFileText size={18} className="text-yellow-50" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-richblack-5">Assessment Setup</h1>
          <p className="text-sm text-richblack-400">{course.courseName}</p>
        </div>
      </div>
      <div className="mx-auto max-w-[700px]">
        <AssessmentForm />
      </div>
    </div>
  )
}
